export default "__VITE_ASSET__CML2n9_k__"